import React from 'react';
import { Box } from '@zillow/constellation-10';

const LoadingContainer = ({
  children,
  ...props
}: React.ComponentProps<typeof Box>) => (
  <Box
    css={{
      position: 'fixed',
      top: '50%',
      left: '50%',
      transform: 'translate(-50%, -50%)',
    }}
    {...props}
  >
    {children}
  </Box>
);

export default function LoadingIndicator() {
  return <LoadingContainer>Loading...</LoadingContainer>;
}
